import React from "react";
import PortfolioContainer from "./components/PortfolioContainer";
import 'bootstrap/dist/css/bootstrap.min.css'

const App = () => <PortfolioContainer />


export default App;